import React, { useMemo, useState } from "react";

import { Input } from "Components/Form";
import { InputProps } from "Components/Form/Input";
import { useTranslation } from "react-i18next";

import { SearchItem, SearchItemIput } from "./SearchItem";
import {
  SearchItemContainerFooter,
  SearchItemContainerFooterButton,
  SearchItemListContainer,
  SearchSelectBodyContainer,
  SearchSelectContainer,
} from "./styles";

interface SearchSelectProps {
  inputProps: InputProps;
  items: SearchItem[];
  checkedCount: number;
  handleChange: (id: string) => void;
  handleSelectAll: () => void;
  handleUnselectAll: () => void;
}

export const SearchSelect = ({
  inputProps,
  items,
  checkedCount,
  handleChange,
  handleSelectAll,
  handleUnselectAll,
}: SearchSelectProps) => {
  const { t: translate } = useTranslation();
  const [search, setSearch] = useState("");
  const itemsFiltered = useMemo(() => {
    if (search?.length) {
      return items?.filter((item) => item.label.toLowerCase().includes(search.toLowerCase()));
    }

    return items;
  }, [search, items]);

  return (
    <SearchSelectContainer>
      <Input {...inputProps} value={search} onChange={(e) => setSearch(e.target.value)} />
      <SearchSelectBodyContainer>
        <SearchItemListContainer>
          {itemsFiltered?.map((item) => (
            <SearchItemIput
              key={item.value}
              item={item}
              handleChange={handleChange}
              disabled={inputProps?.disabled}
            />
          ))}
        </SearchItemListContainer>
        <SearchItemContainerFooter>
          <SearchItemContainerFooterButton
            onClick={() => !inputProps?.disabled && handleSelectAll()}
            disabled={checkedCount === items?.length || inputProps?.disabled}
          >
            {translate("selectAll")}
          </SearchItemContainerFooterButton>
          <SearchItemContainerFooterButton
            onClick={() => !inputProps?.disabled && handleUnselectAll()}
            disabled={checkedCount === 0 || inputProps?.disabled}
          >
            {translate("unselectAll")}
          </SearchItemContainerFooterButton>
        </SearchItemContainerFooter>
      </SearchSelectBodyContainer>
    </SearchSelectContainer>
  );
};
